var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dog-purchase-transaction"},[(!_vm.isNativeApp)?_c('client-header',{attrs:{"showMainLogo":true}}):_vm._e(),_c(_vm.selectedRoute,{tag:"component",attrs:{"dogPurchaseDetails":_vm.dogPurchaseDetails}}),(!_vm.isNativeApp)?_c('the-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }